import { initializeApp } from 'firebase/app';
import * as firebaseMessaging from 'firebase/messaging';
const vapidKey = 'BPuVmAwGntDcZW3hXbx7ne3gxU__z6u9IFOZnw9DdF2fF9PvvI-de5yafqANXWgPR5Mm_6qZVeaaygtrplRkJRI';

const firebaseConfig = {
  apiKey: "AIzaSyAzOlZIoGgsjZl8PCBVufURHxope0hlVvU",
  authDomain: "clexi-info.firebaseapp.com",
  projectId: "clexi-info",
  storageBucket: "clexi-info.appspot.com",
  messagingSenderId: "5313170015",
  appId: "1:5313170015:web:52a9741634cf0e3029e9ea",
  measurementId: "G-WW4PB1RHQW",
};

// Create a firebase app and get the messaging instance to receive notifications
const firebaseApp = initializeApp(firebaseConfig);
let messaging;
(async () => {
	messaging = await firebaseMessaging.isSupported() ? firebaseMessaging.getMessaging(firebaseApp) : null;
})();

/**
 * Get a new or previous fcm token
 * @returns {Promise<string>} The fcm token
 */
export const getFcmToken = async () => {
	try {
		if (await firebaseMessaging.isSupported())
		{
			const currentToken = await firebaseMessaging.getToken(messaging, { vapidKey });
			return currentToken;
		} else return null;
	} catch (error) {
		console.error(error);
	}
};

/**
 * Listen on incoming notifications
 * @param {(payload: object ) => void} callback - A callback that is called when a new notification is received
 * @returns {void}
 */
export const onMessage = async callback => {
	await firebaseMessaging.isSupported() ? firebaseMessaging.onMessage(messaging, callback) : callback();
};
